export const WALL_SYMBOL = "#";
export const WALL_VALUE = 1;

export const PASS_SYMBOL = " ";
export const PASS_VALUE = 0;

export const USER_SYMBOL = {
  TOP: "^",
  BOTTOM: "v",
  LEFT: "<",
  RIGHT: ">",
};
